import React, { useState, useEffect } from 'react';
import { Box, Container, Typography, Grid, Card, CardContent, CardMedia, CircularProgress } from '@mui/material';
import { csrService } from '../services/api';
import { getImageUrl } from '../utils/assets';
import SimplePageBanner from '../components/SimplePageBanner';
import { bodyTextSx, cardSx, BRAND, COLORS, sectionPaddingSx, cardHeadingSx } from '../theme/pageStyles';

const CSRPage = () => {
  const [activities, setActivities] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchActivities = async () => {
      try {
        const response = await csrService.getCSRActivities();
        setActivities(response.data?.data || response.data || []);
      } catch (error) {
        console.error('Error fetching CSR activities:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchActivities();
  }, []);

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '400px' }}>
        <CircularProgress sx={{ color: BRAND.green }} />
      </Box>
    );
  }

  return (
    <Box sx={{ overflow: 'hidden' }}>
      <SimplePageBanner
        subtitle="Partnerships"
        title="Corporate Social Responsibility"
        description="Our initiatives and partnerships for creating lasting social impact."
      />

      <Box sx={{ backgroundColor: '#FAF9F6', ...sectionPaddingSx }}>
      <Container maxWidth={false} sx={{ width: '100%', px: { xs: 2, sm: 3 } }}>
        {activities.length === 0 ? (
          <Typography sx={{ ...bodyTextSx, textAlign: 'center', color: COLORS.body }}>No CSR activities available</Typography>
        ) : (
          <Grid container spacing={4}>
            {activities.map((activity, index) => (
              <Grid item xs={12} key={activity.id}>
                <Card sx={{ display: 'flex', flexDirection: index % 2 === 0 ? 'row' : 'row-reverse', ...cardSx }} elevation={0}>
                  {activity.image_url && (
                    <CardMedia
                      component="img"
                      sx={{ width: { xs: '100%', md: 300 }, maxHeight: { xs: 220, md: 'none' }, objectFit: 'cover' }}
                      image={getImageUrl(activity.image_url)}
                      alt={activity.title}
                    />
                  )}
                  <CardContent sx={{ flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'center', p: 3 }}>
                    <Typography sx={{ ...cardHeadingSx, color: BRAND.green, mb: 1 }}>{activity.title}</Typography>
                    {activity.organization_name && (
                      <Typography sx={{ ...bodyTextSx, fontSize: 13, mb: 1 }}><strong>Partner:</strong> {activity.organization_name}</Typography>
                    )}
                    <Typography sx={{ ...bodyTextSx, mb: 2 }}>{activity.description}</Typography>
                    {activity.impact_summary && (
                      <Box sx={{ backgroundColor: COLORS.cream, p: 2, borderRadius: 1 }}>
                        <Typography sx={{ ...bodyTextSx, fontWeight: 600, color: BRAND.green, mb: 0.5 }}>Impact:</Typography>
                        <Typography sx={{ ...bodyTextSx, fontSize: 13 }}>{activity.impact_summary}</Typography>
                      </Box>
                    )}
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid>
        )}
      </Container>
      </Box>
    </Box>
  );
};

export default CSRPage;
